import { IEnvironment } from './environment.interface';
import { version } from './version';

// This file is templated by the test-slot deploy workflow before build.
export const environment: IEnvironment = {
  version,
  production: false,
  mock: false,
  authIdleTimeoutSeconds: 1800,
  url_backend: 'https://test-1.practice-mgmt-dev.com/',
  url_servicios: 'https://test-1.practice-mgmt-dev.com/api',
  url_frontend: 'https://test-1-app.practice-mgmt-dev.com/',
  url_media: 'https://test-1.practice-mgmt-dev.com/storage/',
  showProductionWarning: false,
};
